import React, { createContext, useContext } from "react";

const TabsContext = createContext({ value: "", onValueChange: () => {} });

export function Tabs({ value, onValueChange, className = "", children }) {
	return (
		<TabsContext.Provider value={{ value, onValueChange }}>
			<div className={`grader-tabs ${className}`.trim()}>{children}</div>
		</TabsContext.Provider>
	);
}

export function TabsList({ className = "", children }) {
	return <div className={`grader-tabs__list ${className}`.trim()}>{children}</div>;
}

export function TabsTrigger({ value, className = "", children }) {
	const { value: active, onValueChange } = useContext(TabsContext);
	const isActive = active === value;
	return (
		<button
			type="button"
			role="tab"
			aria-selected={isActive}
			className={`grader-tabs__trigger${isActive ? " grader-tabs__trigger--active" : ""} ${className}`.trim()}
			onClick={() => onValueChange(value)}
		>
			{children}
		</button>
	);
}

export function TabsContent({ value, className = "", children }) {
	const { value: active } = useContext(TabsContext);
	if (active !== value) return null;
	return (
		<div className={`grader-tabs__content ${className}`.trim()} role="tabpanel">
			{children}
		</div>
	);
}
